module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy4zNDIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNy4zNDIgMTgiPgogIDxwYXRoIGlkPSJfX1RFTVBfX1NWR19fIiBkPSJNOC40ODQsMjAuNWEyLjE3OCwyLjE3OCwwLDAsMCwyLjMxMiwyaDkuMjQ5YTIuMTc4LDIuMTc4LDAsMCwwLDIuMzEyLTJWOUg4LjQ4NFpNMjQuMDkyLDZIMTkuNzU2TDE4LjMwNSw0LjVIMTIuNTM3TDExLjA4NSw2SDYuNzVWNy41SDI0LjA5MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02Ljc1IC00LjUpIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/delete_icon.svg
// module id = wRVn
// module chunks = 1